
import React from 'react';

function DropdownIcon() {

	return (
		<div className='btn--full-width__icon '>
			<svg className='btn--full-width__icon dropdown-icon' width="15" height="9" viewBox="0 0 15 9" fill="current" xmlns="http://www.w3.org/2000/svg">
				<path d="M6.49398 8.67048C6.88448 9.10984 7.51864 9.10984 7.90913 8.67048L13.9071 1.92179C14.2976 1.48243 14.2976 0.768893 13.9071 0.329526C13.5166 -0.109842 12.8825 -0.109842 12.492 0.329526L7.2 6.28383L1.90802 0.33304C1.51752 -0.106327 0.883362 -0.106327 0.492868 0.33304C0.102373 0.772407 0.102373 1.48594 0.492868 1.92531L6.49086 8.67399L6.49398 8.67048Z" fill="current"/>
			</svg>
		</div>
	);
}
export default DropdownIcon;
